
/*
  Author: Vinod
  Date: 23/01/2020
  Issue Description: When changes made to the Payslip Preferences at PG and on clicking Save, no action being performed.
  Issue Id: PL_2480

 */

<template>
  <div class="business">
    <div class="top-bar">
      <span @click="$emit('payslippreferences', {})">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">Payslip Preferences</span>
    </div>
    <div class="content-new">
      <section class="main-content-section">
        <tl-tabs :tabs="tabs">
          <tl-tab>
            <!-- PL_2480 -->
            <monthly-payslips
              :isFromPaygroup="true"
              :isCustom="isCustom"
              @goBackToPaygroup="(val) => $emit('payslippreferences', val)"
            ></monthly-payslips>
          </tl-tab>
          <tl-tab>
            <fnf-payslips
              :isFromPaygroup="true"
              @goBackToPaygroup="(val) => $emit('payslippreferences', val)"
            ></fnf-payslips>
          </tl-tab>
        </tl-tabs>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MonthlyPayslips from "../preferences/MonthlyPayslips.vue";
import FnfPayslips from "../preferences/FnfPayslips.vue";
export default {
  props: {
    isCustom: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MonthlyPayslips,
    FnfPayslips
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      editMode: "onboard/paygroup/editMode"
    }),
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Save";
      }
    }
  },

  data() {
    return {
      tabs: [
        {
          header: "Monthly Payslip"
        },
        {
          header: "FnF Payslip"
        }
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.business {
  width: 100%;
  height: 100%;
  margin-bottom: 200px;
  .top-bar {
    height: 64px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
    }
  }
}

.content-new {
  margin: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
</style>
